/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Commandautomatep22Inputs */



/**
* | output |
* | --- |
* | "Automate command right/low pump" |
*
* @param {Br_History_Key_Commandautomatep22Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_commandautomatep22 = /** @type {((inputs?: Br_History_Key_Commandautomatep22Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Commandautomatep22Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Automate command right/low pump")
	return /** @type {LocalizedString} */ ("Commande automate pompe droite/basse")
});
export { br_history_key_commandautomatep22 as "br_history_key_commandAutomateP2" }